import { Box, CSSObject } from "@mantine/core";
import { CSSProperties, ReactNode } from "react";
import { BreakpointPxs } from "theme/breakpoints";

import { useStyles } from "./styles";

type ContentContainerProps = CSSProperties & {
  children: ReactNode;
  size?: BreakpointPxs;
  flex?: CSSObject["flex"];
  contentSpacing?: CSSObject["justifyContent"];
};

export const ContentContainer = ({
  children,
  size = 768,
  flex,
  contentSpacing = "flex-start",
  ...styles
}: ContentContainerProps) => {
  const { classes } = useStyles({ size, flex, contentSpacing, ...styles });

  return <Box className={classes.container}>{children}</Box>;
};
